import { truncate as _truncate } from 'Data/aggregate.js'

export function showToPrefix(value, noTo) {
  return value && !noTo
}

export function truncate(value) {
  return _truncate(value.trim(), '15')
}
